export default function CustomerBenefits() {
  const benefits = [
    {
      icon: 'ri-money-dollar-circle-fill',
      title: 'Competitive Wholesale Pricing',
      description: 'Volume discounts and bulk pricing options that fit your budget. The more you order, the more you save.',
      color: 'bg-emerald-50',
      iconColor: 'text-emerald-600'
    },
    {
      icon: 'ri-palette-fill',
      title: 'Full Customization Available',
      description: 'Custom print your logo, brand colors, and designs. Create unique packaging that represents your business.',
      color: 'bg-amber-50',
      iconColor: 'text-amber-600'
    },
    {
      icon: 'ri-rocket-fill',
      title: 'Fast Nationwide Shipping',
      description: 'Quick turnaround times with reliable delivery across the United States. Get your order when you need it.',
      color: 'bg-blue-50',
      iconColor: 'text-blue-600'
    },
    {
      icon: 'ri-customer-service-2-fill',
      title: 'Dedicated Support Team',
      description: 'Expert customer service ready to assist with orders, customization, and any questions you may have.',
      color: 'bg-purple-50',
      iconColor: 'text-purple-600'
    },
    {
      icon: 'ri-box-3-fill',
      title: 'Flexible Order Quantities',
      description: 'Whether you need a small batch or large volume, we accommodate orders of all sizes to meet your needs.',
      color: 'bg-rose-50',
      iconColor: 'text-rose-600'
    },
    {
      icon: 'ri-award-fill',
      title: 'Quality Guaranteed',
      description: 'Premium materials and rigorous quality control ensure every bag meets our high standards of excellence.',
      color: 'bg-teal-50',
      iconColor: 'text-teal-600'
    }
  ];

  return (
    <section id="benefits" className="py-20 bg-gradient-to-b from-white to-[#f5f8f2]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-[#5a7c3e] mb-4">
            Why Choose Green Choice Bag
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Partner with us for reliable service, exceptional quality, and sustainable packaging solutions that benefit your business and the environment
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className="bg-white p-8 rounded-xl shadow-md hover:shadow-xl transition-all hover:-translate-y-1"
            >
              <div className={`w-16 h-16 ${benefit.color} rounded-xl flex items-center justify-center mb-6`}>
                <i className={`${benefit.icon} text-3xl ${benefit.iconColor}`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{benefit.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{benefit.description}</p>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-white rounded-2xl shadow-lg p-10 md:p-12">
          <div className="grid md:grid-cols-3 gap-8 text-center">
            <div>
              <div className="text-4xl font-bold text-[#5a7c3e] mb-2">250</div>
              <div className="text-sm text-gray-600 font-medium">Bags Per Carton</div>
            </div>
            <div>
              <div className="text-4xl font-bold text-[#5a7c3e] mb-2">70 lbs</div>
              <div className="text-sm text-gray-600 font-medium">Premium Paper Weight</div>
            </div>
            <div>
              <div className="text-4xl font-bold text-[#5a7c3e] mb-2">100%</div>
              <div className="text-sm text-gray-600 font-medium">Recycled Materials</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
